import Marquee from "react-fast-marquee";
import { useReducedMotion } from "framer-motion";

const ITEMS = ["Dog grooming", "Stress-free environment", "Wethersfield, CT", "Pawtastic Cuts", "The Grass Wall"];
const REPEATED = [...ITEMS, ...ITEMS, ...ITEMS];

export default function MarqueeBand() {
  const reducedMotion = useReducedMotion();
  return (
    <div data-testid="marquee-band" className="overflow-hidden border-y border-lavender-800/20 bg-lavender-700 py-4 text-white">
      <Marquee speed={35} gradient={false} pauseOnHover play={!reducedMotion}>
        {REPEATED.map((item, i) => (
          <span key={i} className="inline-flex items-center border-r border-white/30 px-8 font-serif text-lg italic tracking-wide sm:px-12 sm:text-xl">
            {item}
          </span>
        ))}
      </Marquee>
    </div>
  );
}
